import { Grid, Box, Section } from "@radix-ui/themes";
import { Card } from "~/components/home/Card";
import {
  Locale,
  type LocalizedStrings,
  useLocalization,
} from "~/components/localization/LocalizationProvider";

type Localization = {
  financingTitle: string;
  financingDescription: string;
  financingAlt: string;

  scheduleTitle: string;
  scheduleDescription: string;
  scheduleAlt: string;

  orthoTitle: string;
  orthoDescription: string;
  orthoAlt: string;
};

const englishLocalization: Localization = {
  financingTitle: "Need Flexible Financing?",
  financingDescription:
    "We work with any budget and offer flexible payment options!",
  financingAlt: "Image for flexible financing.",

  scheduleTitle: "Busy Schedule?",
  scheduleDescription: "Visit us Monday–Friday, 8:30am–5pm.",
  scheduleAlt: "Image for flexible schedule.",

  orthoTitle: "Ortho For All Ages",
  orthoDescription:
    "Everyone deserves a beautiful smile - children, teens and adults.",
  orthoAlt: "Image for orthodontics for all ages.",
};

const spanishLocalization: Localization = {
  financingTitle: "¿Necesitas financiamiento flexible?",
  financingDescription:
    "¡Trabajamos con cualquier presupuesto y ofrecemos opciones de pago flexibles!",
  financingAlt: "Imagen para financiamiento flexible.",

  scheduleTitle: "¿Agenda ocupada?",
  scheduleDescription:
    "Visítanos de lunes a viernes, de 8:30am a 5pm.",
  scheduleAlt: "Imagen para horario flexible.",

  orthoTitle: "Ortodoncia para todas las edades",
  orthoDescription:
    "Todos merecen una sonrisa hermosa: niños, adolescentes y adultos.",
  orthoAlt: "Imagen para ortodoncia para todas las edades.",
};

const localized: LocalizedStrings<Localization> = {
  [Locale.EN]: englishLocalization,
  [Locale.ES]: spanishLocalization,
};

export function Schedules() {
  const getLocalization = useLocalization(localized);
  return (
    <Section px={{ initial: "4", sm: "9" }}>
      <Grid columns="12" rows="auto" gapX={{ initial: "2", sm: "4", md: "7" }}>
        <Box height="100%" gridColumn={{ initial: "1 / 13", sm: "1 / 5" }}>
          <Card
            imageSrc="/financing/finance.jpg"
            imageSrcSet="/optimized/financing-finance-352.webp 352w, /optimized/financing-finance-704.webp 704w"
            imageSizes="(max-width: 767px) calc(100vw - 64px), 31vw"
            heading={getLocalization("financingTitle")}
            description={getLocalization("financingDescription")}
            alt={getLocalization("financingAlt")}
            to="/insurance-finances"
          />
        </Box>
        <Box height="100%" gridColumn={{ initial: "1 / 13", sm: "5 / 9" }}>
          <Card
            imageSrc="/financing/flexible-schedule.jpg"
            imageSrcSet="/optimized/financing-flexible-schedule-352.webp 352w, /optimized/financing-flexible-schedule-704.webp 704w"
            imageSizes="(max-width: 767px) calc(100vw - 64px), 31vw"
            heading={getLocalization("scheduleTitle")}
            description={getLocalization("scheduleDescription")}
            alt={getLocalization("scheduleAlt")}
            to="/free-consult"
          />
        </Box>

        <Box height="100%" gridColumn={{ initial: "1 / 13", sm: "9 / 13" }}>
          <Card
            imageSrc="/financing/all-ages.jpg"
            imageSrcSet="/optimized/financing-all-ages-352.webp 352w, /optimized/financing-all-ages-704.webp 704w"
            imageSizes="(max-width: 767px) calc(100vw - 64px), 31vw"
            heading={getLocalization("orthoTitle")}
            description={getLocalization("orthoDescription")}
            alt={getLocalization("orthoAlt")}
            to="/orthodontics-for-all-ages"
          />
        </Box>
      </Grid>
    </Section>
  );
}
